// @core/api/endpoints/signature/list_parties_by_target.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPartiesResponse,
} from '../../../types/signature';

const BASE_PATH = '/signature';

/**
 * List parties of a target
 * Returns all signing parties attached to the given polymorphic target (document, order, task, invoice, consent record, ...). Handy for domain UIs rendering a signature block.
 */
export async function ListPartiesByTarget(
  target_type: string,
  target_id: string,
  params?: {
    limit?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListPartiesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/targets/:target_type/:target_id/parties`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.get<ListPartiesResponse>(requestPath, { ...requestOptions, params });
}
